export default __webpack_public_path__ + "static/media/women-3.856d108d.png";